import React, { useCallback, useEffect, useState } from 'react';
import { Alert, Box, CircularProgress, Stack, Typography } from '@mui/material';
import NotificationSnackbar from '../../../components/notificationSnackbar';
import FeatureFlagCard from './featureFlagCard';
import { listFeatureFlags } from './featureFlags.service';

/**
 * Feature flags: release a change to chosen ecosystems, personas or users (and/or a percentage of all
 * users), and switch it off again, without a deploy. Each environment keeps its own settings.
 */
function FeatureFlags() {
    const [flags, setFlags] = useState(null);
    const [error, setError] = useState(null);
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

    const notify = useCallback((message, severity) => setSnackbar({ open: true, message, severity }), []);
    const closeSnackbar = () => setSnackbar((prev) => ({ ...prev, open: false }));

    useEffect(() => {
        let active = true;
        listFeatureFlags()
            .then((list) => active && setFlags(list))
            .catch((e) => active && setError(e.message));
        return () => {
            active = false;
        };
    }, []);

    const replace = (saved) => setFlags((current) => current.map((f) => (f.key === saved.key ? saved : f)));

    return (
        <Box>
            <Typography className="app-page-title" sx={{ fontSize: 30, fontWeight: 700, color: '#202124', mb: 1 }}>
                Feature Flags
            </Typography>
            <Typography color="text.secondary" sx={{ mb: 3 }}>
                Release a change to chosen ecosystems, personas or users, or to a percentage of all users, and
                switch it off again without a deploy. These settings apply to this environment only.
            </Typography>

            {error ? <Alert severity="error">{error}</Alert> : null}
            {!flags && !error ? <CircularProgress /> : null}
            {flags ? (
                <Stack spacing={3}>
                    {flags.map((flag) => (
                        <FeatureFlagCard key={flag.key} flag={flag} onSaved={replace} onNotify={notify} />
                    ))}
                </Stack>
            ) : null}

            <NotificationSnackbar
                open={snackbar.open}
                onClose={closeSnackbar}
                message={snackbar.message}
                severity={snackbar.severity}
            />
        </Box>
    );
}

export default FeatureFlags;
